"use client";
import { Image } from "@/components/Image";
import { getAltName } from "@/lib/getAltName";
import clsx from "clsx";
import type { SearchDeparture, SearchTravel } from "front-search-schema/algolia";
import { GuideLocalIcon, SpeakerIcon } from "ui/iconsN";

type Props = {
  travel: SearchTravel;
  departure: SearchDeparture;
};
export const Speakers = ({ travel, departure }: Props) => {
  if (departure.speakers.length === 0) {
    return (
      <div
        className={clsx("h-6 flex gap-1.5 items-center @max-xl/side:mt-1 @xl/side:h-7", {
          "opacity-70": departure.state.registrationStatus === "soon",
        })}
      >
        <div className="size-6 @xl/side:size-7 shrink-0 rounded-full overflow-hidden bg-bg-1 border border-tx-2 text-tx-2 grid place-items-center">
          {departure?.speakerType === "local" || travel.brandCustomerTitle === "Orients" ? (
            <GuideLocalIcon />
          ) : (
            <SpeakerIcon />
          )}
        </div>
        <p className="text-xs font-medium @xl/side:text-sm">
          Avec {getAltName(departure.speakerType, travel.brandCustomerTitle)}
        </p>
      </div>
    );
  }

  return (
    <div
      className={clsx("flex flex-col gap-1 @max-xl/side:mt-1", {
        "opacity-70": departure.state.registrationStatus === "soon",
      })}
    >
      {departure.speakers.map((speaker) => (
        <div key={speaker.id} className="h-6 flex gap-1.5 items-center @xl/side:h-7">
          <div className="size-6 @xl/side:size-7 shrink-0 rounded-full overflow-hidden">
            <Image
              alt={speaker.imageRealname || ""}
              image={{
                id: speaker.id.toString(),
                name: speaker.imageName || "",
                realname: speaker.imageRealname || "",
                type: "speaker",
              }}
              height={{
                type: "ratio",
                value: 100,
              }}
              sizes="182px"
              objectFit="cover"
            />
          </div>
          <p className="text-xs font-medium @xl/side:text-sm">
            {speaker.firstname} {speaker.lastname}
          </p>
        </div>
      ))}
    </div>
  );
};
